import { render, staticRenderFns } from "./IndustriaMosaico.vue?vue&type=template&id=3d8999ad&scoped=true&lang=pug"
import script from "./IndustriaMosaico.vue?vue&type=script&lang=js"
export * from "./IndustriaMosaico.vue?vue&type=script&lang=js"
import style0 from "./IndustriaMosaico.styl?vue&type=style&index=0&id=3d8999ad&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8999ad",
  null
  
)

export default component.exports